import ApiGatewayFunction from "../../UserConfigs/ApiGatewayFunction.js";

// Dedicated Lambda (studio_apiGateway_folders), separate from
// create_asset_handler.py's own endpoint on purpose - see folders_handler.py
// for why. request_type: "studio/folders", routed via request_sub_type.

async function callFoldersApi(appConfig, payload, setIsLoading, setApiResponse) {
  return ApiGatewayFunction(
    { request_type: "studio/folders", client_id: appConfig.clientId, ...payload },
    appConfig.patternAPI,
    appConfig.support_key,
    appConfig.support_id,
    setIsLoading,
    setApiResponse,
    appConfig.testingState
  );
}

export async function listFolders(appConfig, brandId, setIsLoading, setApiResponse) {
  const response = await callFoldersApi(
    appConfig,
    { request_sub_type: "list_folders", brand_id: brandId },
    setIsLoading,
    setApiResponse
  );
  return response?.data?.folders ?? [];
}

export async function createFolder(appConfig, brandId, name, setIsLoading, setApiResponse) {
  const response = await callFoldersApi(
    appConfig,
    { request_sub_type: "create_folder", brand_id: brandId, name },
    setIsLoading,
    setApiResponse
  );
  if (!response?.data?.folder) {
    throw new Error(response?.data?.error || "Couldn't create that folder");
  }
  return response.data.folders ?? [];
}

export async function renameFolder(appConfig, brandId, folderId, name, setIsLoading, setApiResponse) {
  const response = await callFoldersApi(
    appConfig,
    { request_sub_type: "rename_folder", brand_id: brandId, folder_id: folderId, name },
    setIsLoading,
    setApiResponse
  );
  if (!response?.data?.folder) {
    throw new Error(response?.data?.error || "Couldn't rename that folder");
  }
  return response.data.folders ?? [];
}

/** Backend rejects this (409) if the folder still has assets in it - callers must surface response's own error, not treat a failure as an empty-list success. */
export async function deleteFolder(appConfig, brandId, folderId, setIsLoading, setApiResponse) {
  const response = await callFoldersApi(
    appConfig,
    { request_sub_type: "delete_folder", brand_id: brandId, folder_id: folderId },
    setIsLoading,
    setApiResponse
  );
  if (!Array.isArray(response?.data?.folders)) {
    throw new Error(response?.data?.error || "Couldn't delete that folder");
  }
  return response.data.folders;
}

/** folderId of null unfiles the asset - explicitly distinct from omitting it, which the backend rejects. */
export async function setAssetFolder(appConfig, brandId, assetId, folderId, setIsLoading, setApiResponse) {
  const response = await callFoldersApi(
    appConfig,
    { request_sub_type: "set_asset_folder", brand_id: brandId, asset_id: assetId, folder_id: folderId },
    setIsLoading,
    setApiResponse
  );
  if (!response?.data?.asset) {
    throw new Error(response?.data?.error || "Couldn't move that asset");
  }
  return response.data.asset;
}